import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'
import gsap from 'gsap'



class  Eyes extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.ref = {

    }
  }


  mount() {


    var svg = document.querySelector("#svg");
    var smile = document.querySelector("#smile");
    var mouse = svg.createSVGPoint();
    var mouset = smile.createSVGPoint();

    var leftEye = createEye("#left-eye");
    var rightEye = createEye("#right-eye");

    var requestId = null;

    gsap.set(onEyelids, {delay: 2, onRepeat: onEyelids, repeat: -1, repeatDelay: 5});
   

     gsap.set('.pathup', {yPercent: -100})
     gsap.set('.pathdown', {yPercent: 100})

    window.addEventListener("mousemove", onMouseMove)

    function onEyelids() {
        
        gsap.to('.pathup', {
            yPercent: 0, duration: .13, ease: 'power4.out', yoyo: true, repeat: 1
        })
        gsap.to('.pathdown', {
            yPercent: -10, duration: .13, ease: 'power4.out', yoyo: true, repeat: 1
        })
    }

    function onFrame() {

        var point = mouse.matrixTransform(svg.getScreenCTM().inverse());

        leftEye.rotateTo(point);
      //  rightEye.rotateTo(point);

        requestId = null;

        update(point)


    }

    

    function createEye(selector) {

        var element = document.querySelector(selector);
        var RAD2DEG = 180 / Math.PI;

        gsap.set(element, {
            transformOrigin: "center"
        });

        var bbox = element.getBBox();
        var centerX = bbox.x + bbox.width / 2;
        var centerY = bbox.y + bbox.height / 2;

        function rotateTo(point) {

            var dx = point.x - centerX;
            var dy = point.y - centerY;

            var angle = Math.atan2(dy, dx);

            gsap.to(element, {
                rotation: angle * RAD2DEG + "_short", duration: .3
            });
            gsap.to('#right-eye', {
                rotation: angle * RAD2DEG + "_short",
                duration: .3
            });

           
        }

        return {
            element: element,
            rotateTo: rotateTo
        };
    }

    

    var smile = document.querySelector("#smile");
    var path = document.querySelector("#curve");
    var tspan = document.querySelector("#tspan");

    var connected = false;
  
    var startY = 370;
    var startCY = 510;
    var snapDist = 40
    
    //d = "M90,370 Q 286,510 482,370"

    var p0 = { x: 90, y: startY };
    var p1 = { x: 286, y: startCY };
    var p2 = { x: 482, y: startY };


   // smile.addEventListener("mousemove", onMouseMove);



    function update(point) {

        //console.log(point);

        var d = "M" + p0.x + "," + p0.y + " Q" + p1.x + "," + p1.y + " " + p2.x + "," + p2.y;

        path.setAttribute("d", d);

        // if (connected && ((point.y > 460 || point.y < 400) || (point.x > 505 || point.x < 80))) {
        //     connected = false;
            
        //     gsap.to(p1, {
        //         y: 510,
        //         duration: 5,
        //         ease: "elastic.out(1, 0.3)"
        //     });
        // }
        console.log(Math.abs(p1.y - startCY) >  snapDist * 2);

        if (Math.abs(p1.y - startCY) > snapDist * 2) {
            connected = false;
                gsap.to(p1, {
                    y: 510,
                    duration: 1,
                    ease: "elastic.out(1, 0.2)"
                });
        }

         //if (!connected && ((point.y <= 460 && point.y >= 400) && (point.x <= 505 && point.x >= 80))) {
        
    }




    function onMouseMove(event) {
        mouse.x = event.clientX;
        mouse.y = event.clientY;

        mouset.x = event.clientX;
        mouset.y = event.clientY;

        var pointt = mouset.matrixTransform(svg.getScreenCTM().inverse());

        if (!requestId) {
            requestId = requestAnimationFrame(onFrame);
        }

        if (!connected && event.target === path) {
            connected = true;
            gsap.killTweensOf(p1); // Kill any active tweens on the point
        }

        if (connected) {
            p1.y = pointt.y * 2 - (p0.y + p2.y) / 2;
        }

   
    }

  }

  unmount() {
    


  }

}

module.exports = Eyes
